import React from 'react'
import { useHistory } from 'react-router-dom'
import { Form } from 'formik-antd'
import { useAuth } from '../../../services/auth'
import { SignInRequest, useSignIn } from '../../../services/api/auth'
import { defaultPath } from '../../../routes/paths'
import { View } from './View'

type Form = SignInRequest
const initialValues: Form = {
  email: '',
  password: '',
}

export const Container: React.FunctionComponent = () => {
  const history = useHistory()
  const { setAuth } = useAuth()
  const [signIn, { error }] = useSignIn()

  const onSubmit = (form: Form) => {
    return signIn(form).then(({ data }) => {
      setAuth(data.token, data.admin)
      history.push(defaultPath())
    })
  }

  return (
    <View error={error} initialValues={initialValues} onSubmit={onSubmit} />
  )
}
